import CircularProgress from './Base/CircularProgress.vue';
import ConfirmDialog from './Base/ConfirmDialog.vue';
import MediaSelector from './Base/MediaSelector.vue';
import Repeater from './Base/Repeater.vue';
import NestedForm from './Base/NestedForm.vue';
import PasswordGenerator from './Base/PasswordGenerator.vue';
import TimePicker from './Base/TimePicker.vue';
import LoginForm from './Forms/Login.vue';
import ForgotForm from './Forms/Forgot.vue';
import ChangePasswordForm from './Forms/User/ChangePassword.vue';
import ChangePermissionsForm from './Forms/User/ChangePermissions.vue';
import ChangeProfileForm from './Forms/User/ChangeProfile.vue';
import RecoverForm from './Forms/User/Recover.vue';
import CreateUserForm from './Forms/User/Create.vue';
import CountryForm from './Forms/Country/Create.vue';
import LocationForm from './Forms/Location/Create.vue';
import PlaceForm from './Forms/Place/Create.vue';
import ScheduleForm from './Forms/Schedule/Create.vue';
import DayForm from './Forms/Day/Create.vue';
import ProviderForm from './Forms/Provider/Create.vue';
import TagForm from './Forms/Tag/Create.vue';

export const baseComponents = {
  CircularProgress,
  ConfirmDialog,
  MediaSelector,
  Repeater,
  NestedForm,
  PasswordGenerator,
  TimePicker,
};

export const forms = {
  LoginForm,
  ForgotForm,
  ChangePasswordForm,
  ChangePermissionsForm,
  ChangeProfileForm,
  RecoverForm,
  CreateUserForm,
  CountryForm,
  LocationForm,
  PlaceForm,
  ScheduleForm,
  DayForm,
  ProviderForm,
  TagForm,
};

export default {
  ...baseComponents,
  ...forms,
};
